import { Pol } from './pol';
import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { ControlContainer, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-pol-update',
  templateUrl: './pol-update.component.html'
  //viewProviders: [
  //  { provide: ControlContainer, useExisting: NgForm }
  //]
})
export class PolUpdateComponent extends BaseUpdateComponent<Pol> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    //this.addValidatorToFc("Naziv",Validators.required);
  }

}
